import { memo as pureComponent } from 'react'
import isEqual from 'lodash/isEqual'
import get from 'lodash/get'

/*
	this only works with functional components

	we compare or primitive props and for complex props we compare only props provided in `complexPropsList` argument
	right now this should not be used with `children` props as it has no way to detect changes in children components' props
*/

const propsChangeCheck = (complexPropsList = []) => Component => pureComponent(Component, (oldProps, newProps) => {
	let shouldUpdate = false
	if(Object.keys(oldProps).length !== Object.keys(newProps).length) {
		shouldUpdate = true
		return !shouldUpdate
	}

	shouldUpdate = Object.keys(newProps).some(key => {
		const oProp = oldProps[key]
		const nProp = newProps[key]
		const oType = typeof oProp
		const nType = typeof nProp

		if(oType !== nType) {
			return true
		}


		if(oType === 'string' || oType === 'number' || oType === 'boolean' || oType === 'function') {
			return oProp !== nProp
		}
		return false
	})

	if(!shouldUpdate) {
		shouldUpdate = complexPropsList.some(key => {
			return !isEqual(
				get(oldProps, key),
				get(newProps, key)
			)
		})
	}
	return !shouldUpdate
})

export default propsChangeCheck
